import React from 'react'

function RecipeDatabase() {
  return (
    <div className='text-center text-2xl p-20'>CRM</div>
  )
}

export default RecipeDatabase